import { Entity, EntityId, Location } from 'entities-next/common'
import { OrganizationStage } from 'entities-next/fundingRounds'

export enum AssessmentResult {
  MET_VALUE = 'met_value',
  UNMET_VALUE = 'unmet_value',
  NOT_APPLICABLE_VALUE = 'not_applicable_value',
}

export type Assessment = {
  result: AssessmentResult
}

export type OrganizationStagesAssessment = Entity & {
  stages: OrganizationStage[]
} & Assessment

export type OrganizationHeadquartersAssessment = Entity & {
  locations: Location[]
} & Assessment

export type NegativeOrganizationHeadquartersAssessment = Entity & {
  locations: Location[]
} & Assessment

export type OrganizationFoundedAtAssessment = Entity & {
  minimumYear: number
  maximumYear: number
} & Assessment

export type PositiveAssessments = {
  organizationStages?: OrganizationStagesAssessment
  organizationHeadquarters?: OrganizationHeadquartersAssessment
  organizationFoundedAt?: OrganizationFoundedAtAssessment
}

export type NegativeAssessments = {
  negativeOrganizationHeadquarters?: NegativeOrganizationHeadquartersAssessment
}

export type Analysis = Entity & {
  pairingId: EntityId
  positiveAssessments: PositiveAssessments
  negativeAssessments: NegativeAssessments
  score: AnalysisScore
}

export type AnalysisScore = {
  metScorePercentage: number
  unmetScorePercentage: number
  compatibility: number
}

export type DisplayableAssessment = {
  label: string
  result: AssessmentResult
}

export const ANALYSES_STORE_ID = 'analyses'

export type AnalysesState = {
  readonly items: IdIndexedAnalyses
}

export type IdIndexedAnalyses = {
  readonly [analysisId: number]: Analysis
}
